const swiper = new Swiper(".my-swiper", {
    freeMode: true,
    watchSlidesProgress: true,
});
const swiper2 = new Swiper(".my-swiper2", {
    direction: "horizontal",
    mousewheel: true,
    keyboard: {
        enabled: true,
    },
    thumbs: {
        swiper: swiper,
    },
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        // when window width is >= 320px
        480: {
            direction: "vertical",
            pagination: {
                el: ".swiper-pagination",
            },
        }
    }
});


const metaInfo = [...document.querySelectorAll(".product-meta-info")];

class MetaInfo{

    openState = false;
    constructor(element){
        this.element = element;
        this.info = element.querySelector(".product-meta-content");
        this.timeline = gsap.timeline({paused: true});
        this.timeline.to(this.info, {duration: 0.3, height:"auto", ease: "power2.inOut"})
        this.element.addEventListener("click", ()=>{
            if (this.openState){
                this.timeline.reverse();
            }else{
                this.timeline.play();
            }
            this.openState = !this.openState;
        });
    }
}

metaInfo.forEach(element => new MetaInfo(element));

if (document.querySelector(".size-guide-label")){
    const tlSizeGuide = gsap.timeline({paused: true});
    tlSizeGuide.to(".size-chart-wrapper", {duration: 1.2, x:0, ease: "expo.out"})

    document.querySelector(".size-guide-label").addEventListener("click", () => {
        tlSizeGuide.play();
    })

    document.querySelector(".size-close").addEventListener("click", () => {
        tlSizeGuide.reverse();
    })
}


const form = document.querySelector("form[action='/cart/add']");


form.addEventListener("submit", async (e) => {
    e.preventDefault();
    let variantId = form.querySelector('input[name="id"]').value;
    let quantity = 1;

    await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            // Other headers if necessary
        },
        body: JSON.stringify({ id: variantId, quantity: quantity })
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            let oldCount = parseInt(document.querySelector("#cart-count").innerHTML);
            oldCount++
            document.querySelector("#cart-count").innerHTML = String(oldCount)
            console.log(document.querySelector("#cart-count").innerHTML )
            // Successfully added to cart, now update the cart modal and show the modal
            updateCartModal()
                .then(() => {tlCart.play()})
            // Update the modal with the cart item details if necessary
        })
        .catch(error => {
            // Handle errors, possibly by showing a message to the user
            console.error('Error adding item to cart:', error);
        });
});


async function updateCartModal() {
    await fetch('/section_id=cart-drawer')
        .then(response => response.text())
        .then(text => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            document.querySelector('.cart-content-wrapper').innerHTML = html.querySelector('.cart-content-wrapper').innerHTML;
            document.querySelector('.cart-footer-wrapper').innerHTML = html.querySelector('.cart-footer-wrapper').innerHTML;
        })
        .catch(error => {
            console.error('Error updating cart modal:', error);
        });
}

